/**
 * Created by mqamhieh on 11/23/16.
 */
window.JobPreferredLocationForm = function (scope, applicationId, locations) {
    var self = this;
    var formName = "job-preferred-location-form";
    var _protected = BaseForm.call(self, formName, scope);

    self.locations = locations;

    var getSelectedIds = function () {
        var locationIds = [];

        for (var i in locations) {
            if (locations[i].selected) {
                locationIds.push(locations[i].id);
            }
        }

        return locationIds;
    };

    self.load = function () {

    };

    self.save = function () {
        return JobApplicationAPI.saveAppPreferredLocation(applicationId, getSelectedIds());
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        switch (rule.name) {
            case 'at_least_one':
                if (!getSelectedIds().length) {
                    return false;
                }
                break;
        }

        return true;
    };
};